import { pokemonList } from '../data/pokemonList';

// Map of Pokemon names to their Pokedex IDs
const pokemonNameToId = new Map();
const pokemonIdToName = new Map();

// Helper function to safely add a Pokemon to the maps
const safelyAddPokemon = (name, id) => {
  if (name && typeof name === 'string' && typeof id === 'number') {
    pokemonNameToId.set(name.toLowerCase(), id);
    pokemonIdToName.set(id, name);
  }
};

// Initialize maps with initial data
Object.entries(pokemonList).forEach(([name, id]) => safelyAddPokemon(name, id));

// Function to initialize the maps with Pokemon data
export const initializePokemonMaps = (newPokemonList) => {
  // Clear existing maps
  pokemonNameToId.clear();
  pokemonIdToName.clear();
  
  if (Array.isArray(newPokemonList)) {
    // If it's an array from the API
    newPokemonList.forEach(pokemon => {
      if (pokemon && pokemon.name && pokemon.pokedexId) {
        safelyAddPokemon(pokemon.name, pokemon.pokedexId);
      }
    });
  } else if (typeof newPokemonList === 'object' && newPokemonList !== null) {
    // If it's an object like our local pokemonList
    Object.entries(newPokemonList).forEach(([name, id]) => safelyAddPokemon(name, id));
  } else {
    console.error('Invalid Pokemon list format');
  }

  // If maps are empty, use initial data as fallback
  if (pokemonNameToId.size === 0) {
    Object.entries(pokemonList).forEach(([name, id]) => safelyAddPokemon(name, id));
  }
};

// Get Pokemon ID from name
export const getPokemonId = (name) => {
  if (!name) return null;
  const normalizedName = name.toLowerCase().replace(/\s+/g, '-');
  return pokemonList[normalizedName] || null;
};

// Get Pokemon name from ID
export const getPokemonName = (id) => {
  if (!id) return null;
  const numId = Number(id);
  const entry = Object.entries(pokemonList).find(([_, value]) => value === numId);
  return entry ? entry[0] : null;
};

// Check if Pokemon exists by name
export const pokemonExistsByName = (name) => {
  if (!name) return false;
  const normalizedName = name.toLowerCase().replace(/\s+/g, '-');
  return normalizedName in pokemonList;
};

// Check if Pokemon exists by ID
export const pokemonExistsById = (id) => {
  if (!id) return false;
  const numId = Number(id);
  return Object.values(pokemonList).includes(numId);
};

// Get all Pokemon IDs
export const getAllPokemonIds = () => {
  return Array.from(pokemonIdToName.keys());
};

// Get all Pokemon names
export const getAllPokemonNames = () => {
  return Array.from(pokemonNameToId.keys());
};